export const initialState = {
  banList: null,
};
  
export default {
  ...JSON.parse(JSON.stringify(initialState))
};
  

